import percentChanged from "../../../../components/percentChanged/percentChanged";
import { connect } from "react-redux";
export default connect(state => ({ changeValue: -0.02 }))(percentChanged);
